import styled, { css } from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -25px;
`;

export const StyledStatus = styled.p`
  margin-bottom: 24px;
  font-size: 24px;
  color: var(--primary);
`;

export const StyledButtonsWrapper = styled.div`
  color: var(--primary);
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;

  @media only screen and (max-width: 920px) {
    justify-content: center;
  }
`;

export const StyledDownloadButton = styled.button<{ isDisabled?: boolean }>`
  width: 100%;
  color: white !important;
  font-size: 17px !important;
  background-color: var(--primary) !important;
  text-transform: uppercase !important;
  padding: 12px 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 25px !important;
  border-radius: 3px !important;
  font-family: "Inter" !important;
  cursor: pointer;

  ${({ isDisabled }) => isDisabled && css`
    cursor: none;
    pointer-events: none;
    opacity: 0.65;
  `}
`;

// margin-bottom: 24px !important;
export const StyledBondMessage = styled.p`
  margin: 0;
  font-size: 16px;
  color: #000000;
  font-weight: 400;
  line-height: 27px;
`;

export const StyledBuyNowButton = styled.button`
  width: 320px;
  font-size: 18px;
  color: white;
  border-radius: 5px !important;
  background-color: var(--primary);
  text-transform: uppercase !important;
  padding: 16px 0;
  line-height: 18px;
  font-family: "Inter" !important;

  &:disabled {
    opacity: 0.65;
  }
`;
